var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"background":"","layout":"total, sizes, prev, pager, next, jumper","page-size":_vm.msg.pageSize,"current-page":_vm.msg.page,"page-count":_vm.msg.total,"total":_vm.msg.total},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f9f43a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = null
// module chunks = 